module.exports = "\n<div class=\"comp-form-abstract\"></div>";


//////////////////
// WEBPACK FOOTER
// ./assets/js/frontend/components/form/abstract/index.pug
// module id = 693
// module chunks = 4